import axios from 'axios';
import axiosRetry from 'axios-retry';
import { microserviceData } from './config';
import { modes } from '@powerplay/common';
import { Buffer as buffer } from 'buffer';
export class AxiosManager {
    client;
    microserviceData;
    envData;
    constructor(authToken, envData, data = microserviceData) {
        this.microserviceData = data;
        this.envData = envData;
        this.client = axios.create({
            timeout: 50000,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${authToken}`,
                'pps-game-token': this.envData.gameToken || ''
            }
        });
        axiosRetry(this.client, {
            retries: 3,
            retryDelay: (retryCount) => {
                console.log(`retry ${retryCount}`);
                return 5000;
            },
            shouldResetTimeout: true,
            retryCondition: (error) => {
                console.log(error);
                return true;
            }
        });
    }
    async sendRequest(method, action, data, callback, callbackError, jsonPerMode = false) {
        try {
            console.log(`data z requestu ${action}:`, data);
            const prefix = this.envData.host || '';
            const remoteAddress = `${prefix}${this.microserviceData.get(action)}`;
            const actionString = action + (jsonPerMode ? modes.mode : '');
            const response = await this.client.request({
                data,
                url: this.envData.isLocal ?
                    `./local_requests/${actionString}.json` :
                    remoteAddress,
                method: this.envData.isLocal ? 'get' : method
            });
            const serverResponse = response.data;
            console.warn(serverResponse);
            if (serverResponse.error) {
                callbackError(serverResponse.error);
            }
            else {
                callback(serverResponse.data);
            }
        }
        catch (err) {
            callbackError(`${err?.response?.data?.error} | ${err} | ${err?.response?.config?.url}`);
        }
    }
    async getImg64(url, prefix) {
        console.log('GET IMG 64: ', url, prefix);
        if (!prefix) {
            const i = url.lastIndexOf('.');
            prefix = `data:image/${url.substring(i)};base64,`;
        }
        console.log(`prefix: ${prefix}`);
        const response = await axios.get(url, {
            responseType: 'arraybuffer'
        });
        console.log('response: ', response);
        console.log('response.data: ', response.data);
        console.log('Buffer: ', buffer);
        const bufferData = buffer.from(response.data, 'binary');
        console.log('buffer: ', bufferData);
        const img64 = prefix + bufferData.toString('base64');
        console.log('img64: ', img64);
        return img64;
    }
}
//# sourceMappingURL=AxiosManager.js.map